.visible {
  max-height: 260px;
  overflow: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--t-min);
  font-variant-numeric: lining-nums tabular-nums;
}

.table th,
.table td {
  padding: 4px 8px;
  border-bottom: 1px solid var(--line);
  text-align: left;
}

.table th {
  color: var(--muted);
  font-weight: 600;
}

.table td:not(:first-child),
.table th:not(:first-child) {
  text-align: right;
}

.note {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: var(--t-min);
}
